import { Component, OnInit, Output, Input, ViewChild, EventEmitter,OnChanges ,ElementRef, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Config } from '../../config/config';
import * as $ from 'jquery';
import { OnDestroy, SimpleChanges } from '@angular/core';
import { RestDataService } from '../../service/rest-data.service';
import { DragulaService } from 'ng2-dragula';
import { SnotifyService } from 'ng-snotify';
import * as autoScroll from 'dom-autoscroller';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { LocalstorageService } from '../../service/localstorage.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: '.app-page-listing',
  templateUrl: './page-listing.component.html',
  styleUrls: ['./page-listing.component.scss']
})
export class PageListingComponent implements OnInit, OnDestroy, OnChanges {
  domainConfig : any= {};
  listOfPageAdded: any;
  multiplePageFlag: boolean;
  showNewData = false;
  objectKeys = Object.keys;
  pageList: any;
  storyType: string;
  domain: any;
  zoneCollections: any;
  collectionPinList = [];
  @Input()
  set pageId(page_string: string) {
    this.page_id = (page_string && page_string.trim()) ? page_string : '';
  }
  @Input()
  set showPageId(showPageId_string: string) {
    this.showpageId = (showPageId_string) ? showPageId_string : '';
  }
  @Input()
  set allApi(api_string: string) {
    this.api = (api_string && api_string.trim()) ? api_string : '';
  }
  @Input()
  set metaApi(meta_api_string: string) {
    this.meta_api = (meta_api_string && meta_api_string.trim()) ? meta_api_string : null;
  }
  @Input()
  set searchApi(search_api_string: string) {
    this.search_api = (search_api_string && search_api_string.trim()) ? search_api_string : null;
  }
  @Input()
  set pagePinIds(pagePinIdsArray: any[]) {
    this.pagePinList = (pagePinIdsArray && (pagePinIdsArray.length > 0)) ? pagePinIdsArray : [];
  }
  @Input()
  set collectionPinIds(collectionPinIdsArr: any[]) {
    this.collectionPinList = (collectionPinIdsArr && (collectionPinIdsArr.length > 0)) ? collectionPinIdsArr : [];
  }
  @Input()
  set showCollecton(showCollecton: boolean) {
    this.showCollectonData = showCollecton;
  }
  @Input()
  set getnewData(getnewData: boolean) {
    this.showNewData = getnewData;
  }

  @Input()
  set getMultiplePageList(multiplePageList : any){
    this.listOfPageAdded = multiplePageList;
  }
  @Input()
  set isMultiplePage(multiplePageFlag : any){
    this.multiplePageFlag=multiplePageFlag;
  }
  @Input()
  set isPage(isPage_string: string) {
    this.showPage = (isPage_string && isPage_string.trim()) ? isPage_string : null;
  }
  @Input()
  set pageTopic(pageTopic_string: string) {
    this.showPageTopic = (pageTopic_string && pageTopic_string.trim()) ? pageTopic_string : null;
  }
  @Input()
  set pageSection(pageSection_string: string) {
    this.showPageSection = (pageSection_string && pageSection_string.trim()) ? pageSection_string : null;
  }
  @Input()
  set pageCompany(pageCompany_string: string) {
    this.showPageCompany = (pageCompany_string && pageCompany_string.trim()) ? pageCompany_string : null;
  }
  @Input()
  set showSearch(showSearch_string: string) {
    this.pageShowSearch = (showSearch_string && showSearch_string.trim()) ? showSearch_string : null;
  }
  @Input()
  set pageSubSection(pageSubSection_string: string) {
    this.showPageSubSection = (pageSubSection_string && pageSubSection_string.trim()) ? pageSubSection_string : null;
  }
  @Input()
  set getpageName(getpageName_string: string) {
    this.showPageName = (getpageName_string && getpageName_string.trim()) ? getpageName_string : null;
  }
  @Input()
  set getDragulaId(dragulaId_string: string) {
    this.dragulaId = (dragulaId_string && dragulaId_string.trim()) ? dragulaId_string : null;
  }
  @Input()
  set getZoneCollections(tempArray: any) {
    this.zoneCollections = tempArray;
  }
  @Input()
  set mergeArticles(mergeArticles_string: any[]) {
    this.isInArray = (mergeArticles_string && (mergeArticles_string.length > 0)) ? mergeArticles_string : [];
    this.isInTemplateArray = (mergeArticles_string && (mergeArticles_string.length > 0)) ? mergeArticles_string : [];
  }
  @Input()
  set pageManager(pageManager: boolean) {
    this.showPageManager = pageManager;
  }
  @Input()
  set getTitle(getTitle_string: string) {
    this.checkTitle = (getTitle_string && getTitle_string.trim()) ? getTitle_string : null;
  }
  @Input()
  set elementType(elementType: string) {
    this.storyType = (elementType && elementType.trim()) ? elementType : null;
  }

  @Input() isTemplateView: boolean;
  @Input() dummy: number;
  @Input() isTemplateFilled: boolean;

  @Input() design: string;

  @Input() inCollection: boolean;
  @Input() isLimitExceeded: boolean;

  @Input()
  set getSectionName(getSectionName_string: string) {
    this.showSectionName = (getSectionName_string && getSectionName_string.trim()) ? getSectionName_string : null;
  }
  @Output() sendListIdToParentfn = new EventEmitter<any>();
  @Output() sendArticleIdToParentfn = new EventEmitter<any>();
  @Output() sendPageDataToParentfn = new EventEmitter<any>();
  @Output() sendPageToBeDeleted = new EventEmitter<any> ()
  @Output() sendPageArticleIdToParentfn = new EventEmitter<any>();
  @Output() sendSelectedCollection = new EventEmitter<any>();
  matchPopup = false;
  elementid: string;
  routeLinkForList: string;
  page_id: string;
  checkTitle: string;
  showPageManager = false;
  api: string;
  scroll: any;
  isInArray: any[] = [];
  isInTemplateArray: any[] = [];
  iscollectionInArray: any[] = [];
  dragulaId: string;
  showPageName: string;
  showMore = false;
  count = 200;
  pageShowSearch: string;
  showPageTopic: string;
  showPageSection: string;
  showPageCompany: string;
  showPageSubSection: string;
  showPage: string;
  meta_api: string;
  pickDate: string;
  cricketindex = 0;
  showpageId: string;
  expireAt: string;
  filterList: any;
  pagePinList: any;
  flagdata = {};
  indexDrop = 0;
  dragBlock = false;
  showCalendar = false;
  pinClass: string;
  article_api: string;
  public lastPageNum = -1;
  lastScrollTop = 0;
  offset = 5;
  facets: any;
  searchQuery: FormControl = new FormControl();
  listArray: any[] = [];
  listIdArray: any[] = [];
  articleList: any[] = [];
  byArticleId = false;
  noresults = false;
  // relatedStory : boolean;
  showCollectonData = false;
  search_api: string;
  public pageNum = 0;
  pageSize = 50;
  pages = 34;
  filterUrl = {};
  date: Date;

  currentDate = new Date();
  @ViewChild('autoscroll', {static: false}) autoscroll: ElementRef;
  singleCalendarConfig = {
    'singleDatePicker': true,
    'showDropdowns': true,
    'timePicker': true,
    'timePicker24Hour': true,
    'timePickerSeconds': false,
    'showCustomRangeLabel': false,
    'alwaysShowCalendars': true,
    'opens': 'center',
    'drops': 'down',
    'markCurrentDate': true,
    'minDate': this.currentDate,
    'autoApply': true
  };
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  sortByValueOf: string;
  currentRowSelected = 1;
  storyCountLimitForDrag = 100;
  idQueue = [];
  showSectionName: string;
  setPositionClickedId: any = null;
  constructor(private config: Config, private restService: RestDataService,
    private sharedService: SharedDataService,
    private snotify: SnotifyService,
    private dragulaService: DragulaService,
    private localstorageService:LocalstorageService) {
      this.domainConfig = this.sharedService.currentDomainConfiguration;
    this.storyCountLimitForDrag = (this.domainConfig['config']['collection'] && this.domainConfig['config']['collection']['storyCountLimitForDrag'])
      ? this.domainConfig['config']['collection']['storyCountLimitForDrag'] : 100;
    const bag: any = this.dragulaService.find('another-bag');
    if (bag === undefined) {
      dragulaService.setOptions('another-bag', {
        copy: function (el, source) {
          return source.id === 'left';
        },
        accepts: function (el, target, source, sibling) {
          return target.id !== 'left';
        },
        moves: function (el: any, container: any, handle: any): any {
          return (el.className !== 'ex-over-opac');
        },
        copySortSource: false
      });
    }
    const bag1: any = this.dragulaService.find('second-bag');
    if (bag1 === undefined) {
      dragulaService.setOptions('second-bag', {
        copy: function (el, source) {
          return source.id === 'leftp';
        },
        accepts: function (el, target, source, sibling) {
          return target.id !== 'leftp';
        },
        copySortSource: false
      });
    }

    dragulaService.dropModel.subscribe((value) => {
      this.onDropModel(value.slice(1));
    });
    dragulaService.removeModel.subscribe((value) => {
      this.onRemoveModel(value.slice(1));
    });
    dragulaService.drop.subscribe((value) => {
      this.onDrop(value.slice(1));
      if (value[0] === 'second-bag') {
        if (value[2] == null) {
          return;
        }
        if (value[2].id !== 'content' && value[2].id !== value[3].id) {
          value[1].remove();
        }
      }
    });
  }
ngOnChanges(){
  if (this.showCollectonData && this.showNewData && this.showPage === 'story') {
    this.getarticleData();
  }
}
  ngOnInit() {
    console.log(this.showPage + 'rohit' + this.showCollectonData );
    this.domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    if (this.pagePinList) {
      setTimeout(() => {
        const scroll = autoScroll([
          this.autoscroll.nativeElement
        ], {
            margin: 30,
            maxSpeed: 10,
            scrollWhenOutside: true,
            autoScroll: function () {
              return this.down;
            }
          });
      }, 1000);
    }
    this.routeLinkForList = this.config.getKeyInView(this.config.get('views'),
      this.page_id, 'list_router');
    if (this.pageShowSearch === 'false') {
      this.count = 100;
    }
    if(this.showPage==='page' && this.multiplePageFlag === true) {
      this.getMultiplePageData();
    }
    if (this.pagePinList && !this.showCollectonData) {
      this.getDefaultList(0, true, data => {
        if (data && data.length > 0) {
          this.listArray = [];
          this.listIdArray = [];
          this.dataInsertion(data);
          this.noresults = false;
        } else {
          this.noresults = true;
        }
      });
    } else if (this.showCollectonData && this.showPage === 'story') {
      this.getarticleData();
    } else {
      if (this.meta_api) {
        this.restService.http_get(
          this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.meta_api)
        )
          .subscribe(data => {
            this.facets = data;
          });
      //   let metaData=this.localstorageService.getMetaData();
      // console.log('page-listing.component metadata',metaData);
      // this.facets=metaData;
      }
      this.searchQuery.valueChanges
        .pipe(debounceTime(200)
        ,distinctUntilChanged())
        .subscribe(result => {

          this.searchResults(result, 0, true, data => {
            this.pageNum = 0;
            this.listArray = [];
            this.listIdArray = [];
            if (data['content'].length > 0) {
              this.dataInsertion(data['content']);
              this.noresults = false;
            } else {
              this.noresults = true;
            }
          });
        });
      if ((this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['collectionStoryfilters'] &&
        this.domainConfig['config']['collectionStoryfilters']['filters']
        && (this.domainConfig['config']['collectionStoryfilters']['filters']).trim() !== '') && this.inCollection ) {
        const filters = JSON.parse(this.domainConfig['config']['collectionStoryfilters']['filters']);
        this.filterList = this.sharedService.getUpdatedFilters(filters);
      } else {
        const filters = this.config.getFilters(this.config.get('views'), this.page_id);
        this.filterList = this.sharedService.getUpdatedFilters(filters);
      }
    }

  }
  ngOnDestroy() {
    this.snotify.clear();
  }
  getarticleData() {
    if (this.showPage === 'story' && this.pagePinList.length > 0) {
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.api),
        this.pagePinList, result => {
          this.articleList = result;
          if (this.articleList == null) {
            this.articleList = [];
          }
        });
    } else {
      this.dragBlock = true;

    }
  }
  getArticleDataFromCollection(collectionList) {
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.api),
        collectionList, result => {
          this.articleList = result;
          if (this.articleList == null) {
            this.articleList = [];
          }
        });
  }
  getMultiplePageData() {
    if (this.showPage === 'page' &&(this.listOfPageAdded && this.listOfPageAdded.length > 0)) {
      this.restService.http_post(this.config.get('product').baseUrl
        + "/api/cms/page/get-all-by-ids/",this.listOfPageAdded, result => {
          this.pageList = result;
          if (this.articleList == null) {
            this.articleList = [];
          }
        });
    } else {
      this.pageList = [];
      this.dragBlock = true;
    }
  }
  dataInsertion(data) {
    const newID: any = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== null) {
        this.listArray.push(data[i]);
        this.listIdArray.push(data[i].id);
      }
    }
  }
  idToDelete(id) {
    if (this.page_id === 'pages') {
      this.listArray = this.listArray.filter(i => i.id !== id);
      const deleteArray = [];
      for (let i = 0; i < this.listArray.length; i++) {
        if (this.listArray[i] !== null) {
          deleteArray.push(this.listArray[i].id);
        }
      }
      this.sendPageArticleIdToParentfn.emit(deleteArray);
      this.listIdArray = [];
      this.listIdArray = deleteArray;
    }
    if (this.showCollectonData) {
      this.pagePinList.splice(this.pagePinList.indexOf(id), 1);
      this.articleList.splice(this.pagePinList.indexOf(id), 1);
      this.sendArticleIdToParentfn.emit(this.pagePinList);
      this.getarticleData();
    }
  }
  getDefaultList(pageNum, gotoTop, callback) {
    if (this.config.getEndPoint(this.config.get('views'), this.page_id, this.api) !== 'false') {
      let url = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.api);
      if (this.showpageId) {
        url += this.showpageId;
      }
      url += '?size=' + this.pageSize + '&page=' + pageNum;

      if (!this.showpageId) {
        //  if (this.sortByValueOf) {
        //    url += '&sort=' + this.sortByValueOf + ',desc';
        //  }
        if (this.showPage === 'page') {
          url += '&search=status:PUBLISHED,pageType!PRIMARY';
        } else {
          url += '&search=metadata.status:PUBLISHED,metadata.killed:false,metadata.markUnimportant:false';
          if (this.page_id === 'element' || this.page_id === 'template') {
            url += ',type:collection;cricket;toptrends;banner;embed;jsonfeed;placeholder,reusable:true';
          }
        }
        if (this.filterUrl) {
          for (const filter in this.filterUrl) {
            if (filter) {
              url += this.filterUrl[filter];
            }
          }
        }
        url += '&sort=lastPublishedDate,desc';
      }

      // if (this.showPage === 'page') {
      //   url += ',pageType!EXTERNAL';
      // }
      this.restService.http_get(url)
        .subscribe(data => {
          this.pages = data !== null ? (data['totalPages'] > 20 ? 20 : data['totalPages']) : 0;
          if (gotoTop) {
            this.topFunction();
          }
          callback(data);
        });
    } else {
      console.log('url not found');
    }
  }
  pageToDelete() {
    this.showPageTopic = null;
    this.showPageSection = null;
    this.showPageCompany = null;
    this.showPageSubSection = null;
    this.showPageName = null;
    this.showSectionName = null;
    this.sendPageDataToParentfn.emit(
      {
        type: null,
        title: null,
        section: null,
        name: null
      });
  }
  pagesToDelete(id) {
    this.listOfPageAdded.splice(this.listOfPageAdded.indexOf(Number(id)),1);
    this.sendPageToBeDeleted.emit(this.listOfPageAdded);
    this.getMultiplePageData();
  }

  searchResults(query, pageNum, gotoTop, callback) {
    if (this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api) !== 'false') {
      if (this.search_api) {
        let url = this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api)
          + '?size=' + this.pageSize + '&page=' + pageNum;
        if (this.showPage === 'page') {
          url += '&search=status:PUBLISHED,pageType!PRIMARY';
        } else {
          url += '&search=metadata.status:PUBLISHED,metadata.killed:false,metadata.markUnimportant:false';
          if (this.page_id === 'element' || this.page_id === 'template') {
            url += ',type:collection;cricket;toptrends;banner;embed;jsonfeed;placeholder,reusable:true';
          }
        }

        if (this.filterUrl) {
          for (const filter in this.filterUrl) {
            if (filter) {
              url += this.filterUrl[filter];
            }
          }
        }
        if (query && query.trim() !== '') {
          if (this.showPage === 'page') {
          url += ',name~' + StaticDataService.encodeSpecialChar(query);
          // encodeURIComponent(query.trim()).replace(/%3A/g, ':').replace(/%2C/g, ',');
          } else {
            url += ',text~' + StaticDataService.encodeSpecialChar(query);
            // encodeURIComponent(query.trim()).replace(/%3A/g, ':').replace(/%2C/g, ',');
          }
        }
        if(this.storyType === 'communities') {
          url += ',pageType:SUBSECTION';
        }
        // if (this.showPage === 'page') {
        //   url += ',pageType!EXTERNAL';
        // }
        url += '&sort=lastPublishedDate,desc';
        this.restService.http_get(url)
          .subscribe(data => {
            this.pages = data !== null ? (data['totalPages'] > 20 ? 20 : data['totalPages']) : 0;
            if (gotoTop) {
              this.topFunction();
            }
            callback(data);
          },
            error => {
              console.log(error);
            });
      } else {
        this.getDefaultList(pageNum, gotoTop, data => {
          callback(data);
        });
      }
    } else {
      console.log('url not found');
    }
  }
  urlUpdate(ev) {

    this.filterUrl[ev.type] = ev.data;
    this.pageNum = 0;
    this.searchResults(this.searchQuery.value, this.pageNum, true, data => {
      this.listArray = [];
      this.listIdArray = [];
      if (data['content'].length > 0) {
        this.dataInsertion(data['content']);
        this.noresults = false;
      } else {
        this.noresults = true;
      }
    });
  }
  getFilterData(facet_name) {
    if (this.facets && this.facets[facet_name]) {
      return this.facets[facet_name];
    } else {
      return null;
    }
  }
  onDrop(args) {
    const [el, target, source, e] = args;
    if (e != null) {
      this.indexDrop = +e.value;
    }
    if (el.type !== '' && target.id === 'rightp' && el.className === 'gu-transit') {
      if (this.checkTitle) {
        this.sendPageDataToParentfn.emit(
          {
            type: el.type,
            title: el.id,
            section: el.slot,
            name: el.title,
            data: el
          });
          if(this.multiplePageFlag === true){
            this.getMultiplePageData();
          }
      } else {
        this.showPageTopic = null;
        this.showPageSection = null;
        this.showPageCompany = null;
        this.showPageSubSection = null;
        this.showPageName = null;
        this.showSectionName = null;
        this.sendPageDataToParentfn.emit(
          {
            type: '',
            title: '',
            section: '',
            name: ''
          });
      }
    }
  }
  insertCrossDomainStory(storyId, arrayList, type){
    this.restService.http_post(this.config.get('product').baseUrl
    + "/api/cms/story/crossdomain/"+ storyId ,'', result => {
     document.getElementById(storyId).className= 'ex-over-opac';

      let index = arrayList.indexOf(storyId);
      if(index !== -1) {
        arrayList[index] = result.id;
        if (type === 'page') {
          this.sendPageArticleIdToParentfn.emit(arrayList);
        } else {
          this.sendArticleIdToParentfn.emit(arrayList);
        }

      }

    });
  }

  private onDropModel(args) {
    if (this.pageShowSearch === 'false' && (this.articleList.length > 0 || this.listArray.length > 0)) {
      const [el, target, source, targetModel] = args;
      if (this.showCollectonData) {
        if (this.articleList.length < this.storyCountLimitForDrag) {
        if (el.type === '' && this.checkTitle) {
          if (source.id === 'right') {
            this.pagePinList = [];
            for (let i = 0; i < this.articleList.length; i++) {
              if (this.articleList[i] !== null) {
                this.pagePinList.push(this.articleList[i].id);
              }
            }
            this.sendArticleIdToParentfn.emit(this.pagePinList);
          } else {
            const index = this.pagePinList.indexOf(+el.id);
            if (index < 0) {
              this.pagePinList = [];
              for (let i = 0; i < this.articleList.length; i++) {
                if (this.articleList[i] !== null) {
                  this.pagePinList.push(this.articleList[i].id);
                }
              }
              if(this.domain !== el.accessKey) {
                this.insertCrossDomainStory(+el.id,this.pagePinList, 'story');
              } else {
                this.sendArticleIdToParentfn.emit(this.pagePinList);
              }
            } else {
              this.articleList = this.articleList.filter(i => i.id !== +el.id);
              this.pagePinList = [];
              for (let i = 0; i < this.articleList.length; i++) {
                if (this.articleList[i] !== null) {
                  this.pagePinList.push(this.articleList[i].id);
                }
              }
              this.pagePinList.splice(this.indexDrop, 0, +el.id);
              this.sendArticleIdToParentfn.emit(this.pagePinList);
              this.getarticleData();
            }
          }

          this.showCollectonData = true;
        } else {
          this.articleList = [];
          this.sendArticleIdToParentfn.emit(this.pagePinList);
        }
       } else {
        this.articleList = this.articleList.filter((item) => item.id !== +el.id);
        this.snotify.error('Maximum 50 stories allowed in collection', '', this.sharedService.getConfig(false));
     }
      } else if (this.showpageId && source.id !== 'pin') {

        if (source.id === 'right') {
          this.listIdArray = [];
          for (let i = 0; i < this.listArray.length; i++) {
            if (this.listArray[i] !== null) {
              this.listIdArray.push(this.listArray[i].id);
            }
          }
          this.sendPageArticleIdToParentfn.emit(this.listIdArray);
        } else if (el.title === 'cricket') {
          this.cricketindex = this.listIdArray.indexOf(+el.id);
          this.matchPopup = true;
          this.listArray = [];
        } else {
          const index = this.listIdArray.indexOf(+el.id);
          const pinindex = this.pagePinList.findIndex(e => e.article.id === +el.id);
          if (!Boolean(this.pagePinList) || pinindex < 0) {
            if (index < 0) {
              this.listIdArray = [];
              for (let i = 0; i < this.listArray.length; i++) {
                if (this.listArray[i] !== null) {
                  this.listIdArray.push(this.listArray[i].id);
                }
              }
              if(this.domain !== el.accessKey) {
                this.insertCrossDomainStory(+el.id, this.listIdArray, 'page');
              } else {
                this.sendPageArticleIdToParentfn.emit(this.listIdArray);
              }
            } else {
              this.listArray = this.listArray.filter(i => i.id !== +el.id);
              const deleteArray = [];
              for (let i = 0; i < this.listArray.length; i++) {
                if (this.listArray[i] !== null) {
                  deleteArray.push(this.listArray[i].id);
                }
              }
              deleteArray.splice(this.indexDrop, 0, +el.id);
              this.sendPageArticleIdToParentfn.emit(deleteArray);
              this.getDefaultList(0, true, data => {
                if (data && data.length > 0) {
                  this.listArray = [];
                  this.listIdArray = [];
                  this.dataInsertion(data);
                  this.noresults = false;
                } else {
                  this.noresults = true;
                }
              });
              this.getDefaultList(0, true, data => {
                if (data && data.length > 0) {
                  this.listArray = [];
                  this.listIdArray = [];
                  this.dataInsertion(data);
                  this.noresults = false;
                } else {
                  this.noresults = true;
                }
              });
              // this.listArray.splice(this.indexDrop, 0, {id : +el.id});
            }
          }
        }

      } else if (source.id === 'pin') {
        this.sendListIdToParentfn.emit(this.pagePinList);
      }
    }
  }
  private onRemoveModel(args) {
    const [el, target, source] = args;
  }
  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      const milliseconds = date.getTime();
      const res =
        (this.monthNames[date.getMonth()])
        + ' '
        + (date.getDate())
        + ', '
        + (date.getFullYear())
        + ' | '
        + ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours())
        + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes()

        );
      return res;
    } else {
      return 'Set Time';
    }
  }
  showCalendarfn() {
    this.sendListIdToParentfn.emit(true);
  }
  pushStory(storyId, pin) {
    this.sendListIdToParentfn.emit(
      {
        expireAt: null,
        article: {
          id: storyId.id
        }
      }
    );
    if (!pin) {
      this.listArray = this.listArray.filter(function (el) {
        return (el) && (el.id) && (el.id !== storyId.id);
      });
      this.listIdArray = this.listIdArray.filter(function (el) {
        return (el) && (el !== storyId.id);
      });
    } else {
      this.listArray.splice(0, 0, storyId);
      this.listIdArray.splice(0, 0, storyId.id);
    }
  }

  pushCollection(story, pin) {
    this.sendListIdToParentfn.emit(
      {
        expireAt: null,
        article: {
          id: story.id
        }
      }
    );
    if (!pin) {
      this.listArray = this.listArray.filter(function (el) {
        return (el) && (el.id) && (el.id !== story.id);
      });
      this.listIdArray = this.listIdArray.filter(function (el) {
        return (el) && (el !== story.id);
      });
    } else {
      this.listArray.splice(0, 0, story.id);
      this.listIdArray.splice(0, 0, story.id);
    }
  }
  
  htmlToPlaintext(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(new RegExp('<em>', 'g'), '~@em@~').replace(new RegExp('</em>', 'g'), '~@/em@~')
        .replace(/<[^>]+>/gm, '')
        .replace(new RegExp('~@em@~', 'g'), '<em>').replace(new RegExp('~@/em@~', 'g'), '</em>').trim() : '';
    } else {
      return text;
    }
  }

  public selectedDate(value: any, id, positionValue) {
    if (value !== 'undefined') {
      this.showCalendar = false;
     // $('#' + id + 'Pin').addClass('active');
      document.getElementById(id+ 'Pin').classList.add('active');
      this.sendListIdToParentfn.emit(
        {
          expireAt: value.start.unix() * 1000,
          position: positionValue,
          article: {
            id: id
          }
        }
      );
    }
  }

  positionValueChanged(id, expireAt) {
    // Get the value of the input field by item id
    let positionValue:any =  (<HTMLInputElement>document.getElementById(id+'-position-input')).value;

    // DEFAULLT CASE: If the position value is not defined, set it to 0
    if(positionValue == undefined || positionValue == null || positionValue.trim() == '')
      positionValue = 0;

    // Check if the position is already assigned or not
    let positionAlreadyAllotted = this.pagePinList.find(x => x.position == positionValue) || this.collectionPinList.find(x => x.position == positionValue);

    // If position already assigned, show error notification else, update position
    if(positionAlreadyAllotted && positionAlreadyAllotted.article.id == id) {
      this.setPositionClickedId = null;
    } else if(!this.domainConfig.config.collection.positionDuplicacyAllowed && positionAlreadyAllotted &&  positionValue != 0) {
      this.snotify.error('Position already assigned', '', this.sharedService.getConfig(false));
    }else {
      this.sendListIdToParentfn.emit(
        {
          expireAt: expireAt,
          position: positionValue,
          positionChange: true,
          article: {
            id: id
          }
        }
      );

      this.setPositionClickedId = null;
    }

  }

  validatePositionKeyPress(ev: any) {
    // Define all the allowed keys, by keycode
    let keys = {38:true,39:true,40:true,37:true,16:true,8:true,46:true,48:true,49:true, 50:true,51:true,52:true,53:true,
      54:true,55:true,56:true,57:true,96:true,97:true,98:true,99:true,100:true,101:true,102:true,103:true,104:true,105:true};

    // If the pressed key is not listed above, do not perform any action
    if(!keys[ev.keyCode]) { ev.preventDefault(); }
  }

  validateMaxPositionValue(ev: any) {
    // Restrict the max input value to: 999
    if(ev.target.value > 999)
      ev.target.value = 999;
  }

  setPositionClicked(item) {
    // Hold the id of the selected item in a variable
    this.setPositionClickedId = item.article.id;
  }

  getNewTypeVersionDate(datestring) {
    const dt = new Date(datestring.replace('+0000', 'Z'));
    return this.getDate(Math.round(dt.getTime()));
  }

  getNewTypeVersionDateTime(datestring) {
    if (datestring) {
      const date = new Date(datestring);
      const res = (
        (date.getDate()) + ' ' + (this.monthNames[date.getMonth()]) + ' |  ' +
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
        + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes())
        );
      return res;
    } else {
      return '-';
    }
  }
  getDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
    } else {
      return 'not present';
    }
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    if (document.getElementsByClassName('allcontentList') && document.getElementsByClassName('allcontentList').length > 0) {
      document.getElementsByClassName('allcontentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event) {
    if (this.pageShowSearch === 'true') {
      const st = event.srcElement ? event.srcElement.scrollTop : event.target.scrollTop;
      if (this.lastPageNum !== this.pageNum && this.pageNum < this.pages) {
        if (st > this.lastScrollTop + this.offset) {
          if (this.pageNum === 0) {
            this.pageNum = 1;
          }
          this.lastPageNum = this.pageNum;
          this.offset += 500;
          this.lastScrollTop = st;
          this.searchResults(this.searchQuery.value, this.pageNum, false, data => {
            if (this.pagePinList) {
              if (data.length > 0) {
                this.pageNum += 1;
                this.dataInsertion(data);
                this.noresults = false;
              } else {

              }
            } else {
              if (data['content'].length > 0) {
                this.pageNum += 1;
                this.dataInsertion(data['content']);
                this.noresults = false;
              } else {

              }
            }
          });
        }
      }
    }
  }

  templateToggle(ev) {
    this.sendSelectedCollection.emit(ev);
  }

  callToggles(ev, storyId, showRelated, lockBy) {
    const key = ev.keyCode || ev.charCode;
    if (key === 32) {
      ev.preventDefault();
      this.toggleSwitch(storyId, showRelated, lockBy);
      ev.stopPropagation();
    }
  }
  toggleSwitch(storyId, relatedStory, lockBy) {
    if (this.idQueue.indexOf(storyId) === -1) {
      this.idQueue.push(storyId);
      const publishFlag = false;
      const relatedflag = !relatedStory;
      this.restService.http_put(this.config.get('product').baseUrl
        + '/api/cms/story/update/' + storyId +
        ('?showRelated=' + relatedflag + (publishFlag ? '' : '&autoSave=true')),
        {},
        result => {
          this.idQueue.splice(this.idQueue.indexOf(storyId), 1);
          if (result.status === 423) {
            this.snotify.error(result.error, '', this.sharedService.getConfig(false));
          } else {
            const listindex = this.listIdArray.indexOf(storyId);
            const pinindex = this.pagePinList.findIndex(e => e.article.id === storyId);
            // console.log(listindex, this.listArray, this.listIdArray);
            // console.log(pinindex, this.pagePinList);
            if (pinindex > -1) {
              this.pagePinList[pinindex].article.showRelated = result.showRelated;
            } else if (listindex > -1) {
              this.listArray[listindex].showRelated = result.showRelated;
            }
          }
        });
    }
  }

  toggleFade(item) {
    if(this.listOfPageAdded && this.multiplePageFlag) {
      if(this.listOfPageAdded.indexOf(item.id) > -1) {
        return 'ex-over-opac'
      }
    }
    if (this.showPageName === item.name) {
      if (item.pageType !== 'SUBSECTION') {
        return 'ex-over-opac';
      } else if (item.pageType === 'SUBSECTION' && this.showSectionName === item.parentSection.alias) {
        return 'ex-over-opac';
      }
      return '';
    }
    return '';
  }

  cleanLineup() {
    this.articleList = [];
    this.pagePinList = [];
    this.listArray = [];
    this.listIdArray = [];
  }
  getMatchDetailsToParentfn(obj) {
    if (obj) {
      const cricketCard = JSON.parse(JSON.stringify(StaticDataService.defaultCricketCardData));
      cricketCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      cricketCard.match = obj;
      cricketCard.name = obj.matchNameWithDate;
      cricketCard.title = obj.matchNameWithDate;
      this.matchPopup = false;
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        cricketCard, result => {
          this.elementid = result.id;
          if (this.elementid) {
          this.listIdArray.splice(this.cricketindex, 0, this.elementid);
          this.sendPageArticleIdToParentfn.emit(this.listIdArray);
           this.getDefaultList(0, true, data => {
                if (data && data.length > 0) {
                  this.listArray = [];
                  this.listIdArray = [];
                  this.dataInsertion(data);
                  this.noresults = false;
                } else {
                  this.noresults = true;
                }
              });
              this.getDefaultList(0, true, data => {
                if (data && data.length > 0) {
                  this.listArray = [];
                  this.listIdArray = [];
                  this.dataInsertion(data);
                  this.noresults = false;
                } else {
                  this.noresults = true;
                }
              });

        }
      });
    } else {
      this.snotify.error('Select a Option', '', this.sharedService.getConfig(false));
    }
  }
  getPopupValueToParentfn(obj) {
    this.matchPopup = obj;
  }
  domainWiseDisableDrag(item) {
    if(this.isLimitExceeded) {
      return 'ex-over-opac';
    }
    if(this.sharedService.isdomainConfig('collection','sameCollectionDrag') && this.design === 'template'){
      return (this.zoneCollections.indexOf(item.id) > -1) ? 'ex-over-opac':'r';
    } else {
      return ((this.isInArray.indexOf(item.id) > -1) || this.checkCollectionPinList(item.id) || this.disableStoryForDrag(item.crossDomainStories,item.domainId)  || (this.isTemplateView ? this.isTemplateFilled : false)) ? 'ex-over-opac' : 'r';
    }

  }

  checkCollectionPinList(id) {
    for(let collection of this.collectionPinList) {
      if(collection.article.id === id ) {
        return true;
      }
    }
  }
  disableStoryForDrag(storyList,domainId) {
  if(this.sharedService.isdomainConfig('collection','showDomainFilter') &&  this.domain !== domainId && storyList){
    for (let i = 0; i < storyList.length; i++) {
      let index = this.isInArray.indexOf(storyList[i]);
      if(index > -1) { return true; }
    }
  }
  }
}
